const escStagesLocale = {
  escStages: {
    groups: {
      eligibility: "Éligibilité",
      estimate: "Devis",
      installation: "Installation",
      invoicing: "Facturation",
    },
    labels: {
      NONE: "Non déterminé",
      NON_ESC: "Non éligible",
      ESC_BLANK: "Éligible",
      ESTIMATE_GENERATED: "Devis généré",
      ESTIMATE_SIGNED: "Devis signé",
      INSTALLATION_GENERATED: "Installation générée",
      INSTALLATION_SIGNED: "Installation signée",
      INVOICED: "Facturé",
    },
    status: {
      determinationPending: "En attente de détermination",
      nonEligible: "Non éligible CEE",
      currentStep: "Étape en cours : ",
      unknownStatus: "Statut inconnu",
    },
    legend: {
      completed: "Action faite",
      inProgress: "En cours",
      pending: "Non atteint",
    },
    event: {
      user: "Utilisateur",
      userId: "Utilisateur {id}",
      system: "Système",
      systemAction: "Action système",
      userProfile: "Profil : {description}",
      userId_label: "ID : {id}",
      viewDetails: "Voir les détails",
      keys: "clé",
      keys_plural: "clés",
    },
  },
};

export default escStagesLocale;
